import React, { useState } from 'react';
import styles from './AttendancePage.module.css';

import { useDispatch } from 'react-redux';
import { WiThermometer } from 'react-icons/wi';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { MdQrCodeScanner } from 'react-icons/md';
import { BiLogIn, BiLogOut } from 'react-icons/bi'; // Check in/out icons
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { FiEdit } from 'react-icons/fi';
import ResultAndCount from '../../../components/ResultAndCount/ResultAndCount';
import CalendarInput from '../../../components/CalendarInput/CalendarInput';
import DynamicTable from '../../../components/DynamicTable/DynamicTable';
import PaginationTable from '../../../components/PaginationTable/PaginationTable';

const AttendancePage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');

  const dispatch = useDispatch();

  const data = [
    {
      _id: 's1',
      room: 'Room 1',
      checkIn: '10:00 AM  ',
      checkOut: '5:00 PM ',
      absent: 'Sick Leave',
    },
    {
      _id: 's2',
      room: 'Room 1',
      checkIn: '10:00 AM  ',
      checkOut: '5:00 PM ',
      absent: 'Sick Leave',
      leave: '-',
    },
    {
      _id: 's3',
      room: 'Room 1',
      checkIn: '10:00 AM  ',
      checkOut: '5:00 PM ',
      absent: 'Sick Leave',
      leave: '-',
    },
  ];

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        room: item.room || '-',
        checkIn: item.checkIn ? (
          <div className={styles.inlineStatus}>
            <span className={styles.time}>{item.checkIn.split(' By ')[0]}</span>
            <div className={styles.subscriptRow}>
              <div className={styles.divider}></div>
              <WiThermometer className={styles.icon} />
              <IoDocumentTextOutline className={styles.icon} />
            </div>
          </div>
        ) : (
          '-'
        ),

        checkOut: item.checkOut ? (
          <div className={styles.inlineStatus}>
            <span className={styles.time}>
              {item.checkOut.split(' By ')[0]}
            </span>
            <div className={styles.subscriptRow}>
              <div className={styles.divider}></div>
              <WiThermometer className={styles.icon} />
              <IoDocumentTextOutline className={styles.icon} />
            </div>
          </div>
        ) : (
          '-'
        ),

        absent: item.absent ? (
          <div className={styles.inlineStatus}>
            <span className={styles.time}>{item.absent}</span>
            <div className={styles.subscriptRow}>
              <div className={styles.divider}></div>

              <IoDocumentTextOutline
                className={styles.icon}
                onClick={() => console.log('Absent Notes clicked')}
              />
            </div>
          </div>
        ) : (
          '-'
        ),
        leave: item.leave || '-',
      };
    });
  };
  const columnData = getColumnData(data);

  const headings = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: 'checkBox',
    },

    { title: 'Room', accessor: 'room' },
    { title: 'Check in', accessor: 'checkIn' },
    { title: 'Check out', accessor: 'checkOut' },
    { title: 'Marked Absent', accessor: 'absent' },
    { title: 'Leave', accessor: 'leave' },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.resultandcount}>
        <ResultAndCount
          label="Attendance"
          count={'0%'}
          bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
          textColor="Text_Color"
        />
        <ResultAndCount
          label="Days Present"
          count={0}
          bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
          textColor="Text_Color"
        />
        <ResultAndCount
          label="Days Absent"
          count={0}
          bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
          textColor="Text_Color"
        />
        <ResultAndCount
          label="Leaves Count"
          count={0}
          bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
          textColor="Text_Color"
        />

        <ResultAndCount
          label="Absent"
          count={3}
          bgColor="rgba(from var(--Warning_Color) r g b / 0.4)"
          textColor="Text_Color"
        />
      </div>
      <div className={styles.totaltable}>
        <div className={styles.controlsBar}>
          <div className={styles.dateWrapper}>
            <CalendarInput
              label="Select Date"
              required
              value={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              background="var(--Utility_Color1)"
              placeholderColor="var(--Info_Color)"
              iconColor="var(--Grey_Color)"
              borderRadius="12px"
            />
          </div>
        </div>

        <div className={styles.tableBox}>
          <DynamicTable
            headings={headings}
            columnData={columnData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
          <PaginationTable
            data={columnData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default AttendancePage;
